const LoginErrorMessages = {
    LOGIN_ERROR: 'Invalid username or password',
    NETWORK_ERROR: 'Your account has been deactivated. Please contact your administrator for assistance',   
};

const ResetPassword = {
  SUCCESS: 'Link to reset password has been sent to your registered email!',
  USERNAME_ERROR: 'Please enter valid username',
  PASSWORD_ERROR: 'Passwords do not match',
  LINK_EXPIRED: 'Sorry! The link has expired!!',
};

const PreferenceError = {
  PREFERENCE: 'Preference should be in chronological order',
  INCORRECT_PREFERENCE: 'Cannot set preference for empty field',
  SAME_PREFERENCE: 'Cannot set same preference',
};

const sendSms = {
  SMS_NOT_AVAILABLE : 'SMS sending facility is not available for this number',
  SMS_SENDING_FAILED : 'SMS sending failed',
};


export const ERROR = {
    LoginErrorMessages,
    ResetPassword,
    sendSms,
    PreferenceError
}